import { Link } from "react-router-dom";
import { IndiaFlag } from "./IndiaFlag";

export const Header = ({ compact = false }) => (
  <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-md" data-testid="site-header">
    <div className="tricolour-line" />
    <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-3">
      <Link to="/" className="group flex items-center gap-2" data-testid="header-logo-link">
        <IndiaFlag className="h-[14px] w-[21px]" testId="header-india-flag" />
        <span className="font-display text-xl font-semibold text-[#1f2328]">PropertiesforNRI</span>
        <span className="-ml-1.5 self-end pb-[3px] text-xs font-semibold text-[#138808]">.com</span>
      </Link>
      {!compact && (
        <span className="hidden text-[11px] uppercase tracking-[0.14em] text-neutral-500 sm:block" data-testid="header-powered-by">
          Powered by ConectR MatchMaking Technology
        </span>
      )}
    </div>
  </header>
);
